module.exports = __webpack_public_path__ + "static/img/office (9).a0744110.jpg";